var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React, { useMemo } from 'react';
import { createPrefixCls } from '../_utils/string';
const prefixCls = createPrefixCls('icon');
export const Icon = React.forwardRef((_a, ref) => {
    var { className, style, name, size, color, spin } = _a, restProps = __rest(_a, ["className", "style", "name", "size", "color", "spin"]);
    const iconCls = useMemo(() => {
        return classnames([
            prefixCls(),
            prefixCls(name),
            {
                [prefixCls('spin')]: spin
            },
            className
        ]);
    }, [className, name, spin]);
    const iconSty = useMemo(() => {
        return Object.assign({ fontSize: size, color }, style);
    }, [color, size, style]);
    return React.createElement("i", Object.assign({ ref: ref, className: iconCls, style: iconSty }, restProps));
});
Icon.displayName = 'Icon';
export default Icon;
